import { render, staticRenderFns } from "./listNotes.vue?vue&type=template&id=63e1713c&scoped=true"
import script from "./listNotes.vue?vue&type=script&lang=js"
export * from "./listNotes.vue?vue&type=script&lang=js"
import style0 from "./listNotes.vue?vue&type=style&index=0&id=63e1713c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e1713c",
  null
  
)

export default component.exports